import { Route, BrowserRouter as Router, Routes} from "react-router-dom";
import { useState } from "react";
import Form from "./components/Form";
import LoadForm from "./components/Form";

function App() {

  return (
    <div>
      <Router >
        <div>
          <Routes >
            <Route 
            path="/:apiKey/:formId"
            element={<LoadForm />}>
            </Route>
          </Routes>
        </div>
      </Router>
    </div>
  )
}

export default App